import React from "react";

const LookerDashboard = () => {
  return (
    <iframe
      width="100%"
      height="900px"
      border-radius="8px"
      src="https://lookerstudio.google.com/embed/reporting/80994b5d-f7d8-4e02-905c-05598481f794/page/p_u7l30hx3hd"
      style={{ border: 0 }}
      allowFullScreen
      sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      title="Looker Dashboard"
    ></iframe>
  );
};

export default LookerDashboard;
